import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AppContext from 'src/AppContext';
import { Popover } from 'Components';
import './Helper.css';

const Helper = (props) => {
  const domRef = React.createRef();

  if (props.text === undefined || props.text === '') return props.children;

  const isTop = props.placement.split('-')[0] === 'top';

  return (
    <span
      className={classNames('helper', { 'helper--active': props.isTutorialShowing }, props.className)}
      ref={domRef}
      title={props.title || ''}
    >
      <div className="helper-children__container">
        {!isTop && props.children}
        <div
          className={classNames('helper-children__container', {
            'helper-children__container__popover--bottom-left': props.placement === 'bottom-left',
            'helper-children__container__popover--bottom-right': props.placement === 'bottom-right',
            'helper-children__container__popover--top-left': props.placement === 'top-left',
            'helper-children__container__popover--top-right': props.placement === 'top-right',
          })}
        >
          {props.isTutorialShowing && (
            <Popover domRef={domRef} placement="none" className="helper-children__container__popover">
              {props.text}
            </Popover>
          )}
        </div>
        {isTop && props.children}
      </div>
    </span>
  );
};

Helper.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  isTutorialShowing: PropTypes.bool,
  placement: PropTypes.string,
  className: PropTypes.string,
};

Helper.defaultProps = {
  placement: 'bottom-right',
};

export default (props) => (
  <AppContext.Consumer>
    {(context) => <Helper {...props} isTutorialShowing={context.isTutorialShowing} />}
  </AppContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/components/Helper/Helper.jsx